import { isEqual } from 'lodash/fp';
import { DateTime } from 'luxon';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { Verification } from 'dashboard/models/verification';
import {
  VerificationsActions,
  VerificationsActionType,
  VerificationsFilterParams,
} from 'dashboard/redux/actions/verifications';

export type Verifications = Record<string, Verification[]>;

export const getInitialVerificationsFilterState = (): VerificationsFilterParams => {
  const currentTime = DateTime.local();
  return {
    omni: undefined,
    checks: undefined,
    createdAtStart: currentTime.minus({ weeks: 1 }).startOf('day').toUTC().toISO(),
    createdAtEnd: currentTime.endOf('day').toUTC().toISO(),
    updatedAtStart: undefined,
    updatedAtEnd: undefined,
    status: [],
    type: [],
  };
};

export interface VerificationsState extends TableState<VerificationsFilterParams> {
  verifications: Verifications;
}

const getInitialVerificationsState = (): VerificationsState => ({
  verifications: {},
  filters: getInitialVerificationsFilterState(),
  sortParams: {
    sort: 'created_at',
    shouldSortDescending: true,
  },
  paginationParams: undefined,
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
});

export default (
  state: VerificationsState = getInitialVerificationsState(),
  action: VerificationsActions,
) => {
  switch (action.type) {
    case VerificationsActionType.SetVerifications: {
      return {
        ...state,
        verifications: {
          ...state.verifications,
          [action.payload.environment.id]: action.payload.verifications,
        },
        paginationParams: action.payload.paginationParams,
      };
    }

    case VerificationsActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    case VerificationsActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case VerificationsActionType.SetFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }

    case VerificationsActionType.SetSortParams: {
      return {
        ...state,
        sortParams: {
          ...action.payload.sortParams,
        },
      };
    }

    default:
      return state;
  }
};
